import React from "react";
import { Box, Typography } from "@mui/material";

interface UserCountDisplayProps {
  label: string;
  count: number;
}

const UserCountDisplay: React.FC<UserCountDisplayProps> = ({
  label,
  count,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginBottom: 2,
        marginLeft: 2,
        marginRight: 2,
      }}
    >
      <Typography variant="h6" component="div">
        {label}
      </Typography>
      <Typography variant="h4" component="div" color="primary">
        {count}
      </Typography>
    </Box>
  );
};

export default UserCountDisplay;
